(() => {
  const SELECTOR = '[data-japotyle-home-carousel]';

  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.carouselReady === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-japotyle-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-japotyle-slide-dot]'));
    if (slides.length < 2) return;

    carousel.dataset.carouselReady = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const interval = Math.max(3000, Number(carousel.dataset.interval || 5500));
    const autoplay = carousel.dataset.autoplay !== 'false';
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;
    let pointerStartX = null;

    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const stop = () => {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      stop();
      if (!autoplay || reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showSlide(index);
        start();
      });
    });

    carousel.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });
    carousel.addEventListener('pointerup', (event) => {
      if (pointerStartX === null) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 42) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
      start();
    });
    carousel.addEventListener('pointercancel', () => {
      pointerStartX = null;
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    reduceMotion.addEventListener?.('change', start);

    showSlide(activeIndex);
    start();
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
